module.exports = "<div class=\"app app-header-fixed app-aside-fixed\">\n  <app-header *ngIf=\"!isHeaderHidden\"></app-header>\n  <app-side-menu class=\"hidden-print\"></app-side-menu>\n  <router-outlet></router-outlet>\n</div>\n\n<app-page-footer *ngIf=\"!isHeaderHidden\" class=\"hidden-print\"></app-page-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main